export class ResourceService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        'ngInject';
        this._messagingHubService = MessagingHubService;
    }
    getResource(key) {
        return this._messagingHubService.processCommand({
            method: 'get',
            uri: `/resources/${encodeURIComponent(key)}`,
        });
    }
    deleteResource(key) {
        return this._messagingHubService.sendCommand({
            method: 'delete',
            uri: `/resources/${encodeURIComponent(key)}`,
        });
    }
    setResource({ key, type, content }) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: type,
            uri: `/resources/${encodeURIComponent(key)}`,
            resource: content,
        });
    }
    getResources({ skip, take, documentFilter, keyFilter }) {
        let uri = `/resources?$skip=${skip}&$take=${take}`;
        if (documentFilter) {
            uri += `&documentFilter=${encodeURIComponent(documentFilter)}`;
        }
        if (keyFilter) {
            uri += `&keyFilter=${encodeURIComponent(keyFilter)}`;
        }
        return this._messagingHubService.sendCommand({
            method: 'get',
            uri: uri,
        });
    }
}
